import { render, staticRenderFns } from "./ClaimsDeclarationsFilter.vue?vue&type=template&id=75fefca2"
import script from "./ClaimsDeclarationsFilter.vue?vue&type=script&lang=ts"
export * from "./ClaimsDeclarationsFilter.vue?vue&type=script&lang=ts"
import style0 from "./ClaimsDeclarationsFilter.vue?vue&type=style&index=0&id=75fefca2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports